export class TenantStorageOption {
  constructor(
    public id: string,
    public displayName: string,
  ) {}
}

export class S3Bucket extends TenantStorageOption {
  constructor(
    public id: string,
    public displayName: string,
    public bucketName: string,
    public region: string,
    public accessKey: string,
  ) {
    super(id, displayName);
  }
}

export abstract class ITenantStorageOptionRepository {
  insertNew: (
    id: string,
    displayName: string,
    bucketName: string,
    region: string,
    accessKey: string,
    secretKey: string,
    serviceUrl: string,
  ) => Promise<void>;
  delete: (optionToDelete: TenantStorageOption) => Promise<void>;
}
